import UserProvider from "@/services/user.provider.js";
import UserCentralProvider from "@/services/user.central.provider.js";
import toast from '@/plugins/toastify';

const userProvider = new UserProvider();
const userCentralProvider = new UserCentralProvider();

const initialState = {
    is_authen: null,
    is_error: false,
    is_officer: false,
    is_authorized_officer: false,
    user_info: null,
    surrogated_student_id: null,
    surrogated_student_uid: null,
    surrogated_student_info: null,
};

export const user = {
    namespaced: true,
    state: initialState,
    actions: {
        async getUserInfo({ rootState }) {
            let response = null

            if (rootState.keycloak.isAuthenticated) {
                response = await userCentralProvider.getAuthUserInfo()
                    .catch((error) => {
                        this.state.user.is_error = true;
                        toast.error(JSON.stringify(error.response.data.message))
                    });
            }
            else {
                response = await userProvider.getUserInfo()
                    .catch((error) => {
                        this.state.user.is_error = true;
                        toast.error(JSON.stringify(error.response.data.message))
                        if (error.response.data.message === 'Expired token') { // Token Expired
                            sessionStorage.clear();
                            window.location.reload();
                        }
                    });
            }

            if (response) {
                const acl_authorized_officer = [40, 45, 91]; // PRIV_OFFICER, PRIV_OFFICER_X, PRIV_ADMIN
                const acl_officer = [10, 19, 35, 40, 45, 55, 60, 91]; // PRIV_CREG, PRIV_GENED, PRIV_SAFFAIR, PRIV_OFFICER, PRIV_OFFICER_X, PRIV_SCHOLAR, PRIV_TEACHER, PRIV_ADMIN
                const acl_student = [80, 85]; // PRIV_STUDENT, PRIV_STUDENT_X
                const acl_pre_student = [1, 2]; // PRIV_PRE_STUDENT, PRIV_PRE_STUDENT_X

                // เช็ค privilege ว่าสามารถใช้งานระบบได้
                if (
                    !acl_pre_student.includes(response.payload.ticket.privilege) &&
                    !acl_student.includes(response.payload.ticket.privilege) &&
                    !acl_officer.includes(response.payload.ticket.privilege) &&
                    !acl_authorized_officer.includes(response.payload.ticket.privilege)
                ) {
                    this.state.user.is_error = true;
                    toast.error('ไม่มีสิทธิ์ใช้งานระบบ / Unauthorized');
                    return;
                }

                // สิทธิ์เจ้าหน้าที่ทะเบียนฯ
                if (acl_authorized_officer.includes(response.payload.ticket.privilege))
                    this.state.user.is_authorized_officer = true

                // สิทธิ์เจ้าหน้าที่
                if (acl_officer.includes(response.payload.ticket.privilege))
                    this.state.user.is_officer = true

                // สิทธิ์นักศึกษา
                if (acl_student.includes(response.payload.ticket.privilege)) {
                    this.state.user.surrogated_student_id = response.payload.ticket.user_id
                } else {
                    this.state.user.surrogated_student_id = sessionStorage.getItem('surrogated_student_id');
                }

                // สิทธิ์ผู้รายงานตัว
                if (acl_pre_student.includes(response.payload.ticket.privilege)) {
                    this.state.user.surrogated_student_uid = response.payload.ticket.user_id
                } else {
                    this.state.user.surrogated_student_uid = sessionStorage.getItem('surrogated_student_uid');
                }

                // ถ้าเป็นนักศึกษา, ผู้รายงานตัว หรือสวมสิทธิ์ ให้ดึงข้อมูลนักศึกษา, ผู้รายงานตัว
                if (this.state.user.surrogated_student_uid || this.state.user.surrogated_student_id) {
                    const response2 = await userProvider.getUserInfo(this.state.user.surrogated_student_uid, this.state.user.surrogated_student_id)
                        .catch((error) => {
                            sessionStorage.removeItem('surrogated_student_uid');
                            sessionStorage.removeItem('surrogated_student_id');
                            toast.error(JSON.stringify(error.response.data.message));
                        });
                    if (response2)
                        this.state.user.surrogated_student_info = response2;
                    else
                        this.state.user.surrogated_student_info = null;
                }

                this.state.user.user_info = response;
                this.state.user.is_authen = true;
            } else
                this.state.user = initialState;
        },
        logout({ dispatch }) {
            sessionStorage.clear();
            dispatch('keycloak/logout', null, { root: true });

            //router.go(0).catch(() => { }); # router.go bug not reload on safari browser
            // window.location.reload();
        },
        logoutSurrogatedStudent() {
            sessionStorage.removeItem('surrogated_student_uid');
            sessionStorage.removeItem('surrogated_student_id');

            //router.go(0).catch(() => { }); # router.go bug not reload on safari browser
            window.location.reload();
        },
    },
    mutations: {
        setIsAuthen(state, is_authen) {
            state.is_authen = is_authen;
        }
    },
};
